import { InjectionToken } from "@angular/core";
import { GoogleAnalyticsSettings } from "../interfaces/google-analytics-settings";

/**
 * Provide a Injection Token to global settings.
 */
export const NG_GOOGLE_ANALYTICS_SETTINGS_TOKEN =
  new InjectionToken<GoogleAnalyticsSettings>("ng-google-analytics-settings", {
    factory: () => ({ trackingCode: "", enableTracing: false }),
  });
